import hr from './hr.js'

export default class Languages {
	static translations = {
		hr: hr.translations
	}
}
